import { memo } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { Button, Div, Text, useMediaQuery, useTheme } from "react-better-html";

import { useI18n } from "../utils/i18n";

function ErrorPage() {
   const theme = useTheme();
   const mediaQuery = useMediaQuery();
   const error = useRouteError();
   const { t } = useI18n();

   return (
      <Div.column
         width="100%"
         height="100dvh"
         alignItems="center"
         justifyContent="center"
         backgroundImage={`linear-gradient(to top, ${theme.colors.secondary}, ${theme.colors.primary})`}
         padding={theme.styles.space}
         paddingBottom={100}
         overflow="hidden"
      >
         {isRouteErrorResponse(error) ? (
            <>
               <Text
                  fontSize={mediaQuery.size600 ? 100 : mediaQuery.size900 ? 120 : 200}
                  fontWeight={900}
                  lineHeight={mediaQuery.size600 ? "90px" : mediaQuery.size900 ? "120px" : "180px"}
                  color={theme.colors.base}
               >
                  {error.status}
               </Text>
               <Text
                  fontSize={mediaQuery.size900 ? 26 : 52}
                  fontWeight={700}
                  color={theme.colors.base}
                  marginBottom={40}
               >
                  {error.statusText}
               </Text>

               <Text fontSize={mediaQuery.size900 ? 18 : 28} fontWeight={700} color={theme.colors.base} opacity={0.7}>
                  {error.data.replace("Error:", "")}
               </Text>
            </>
         ) : (
            <>
               <Text
                  fontSize={mediaQuery.size600 ? 70 : mediaQuery.size900 ? 120 : 200}
                  fontWeight={900}
                  color={theme.colors.base}
                  marginBottom={60}
               >
                  Oops!
               </Text>
               <Text fontSize={mediaQuery.size900 ? 18 : 40} fontWeight={700} color={theme.colors.base} opacity={0.7}>
                  {JSON.stringify(error, null, 3)}
               </Text>
            </>
         )}

         <Button
            text={t((l) => l.pages.errorPage.home)}
            href="/"
            color={theme.colors.label}
            backgroundColor={theme.colors.base}
            marginTop={theme.styles.space * 2}
         />
      </Div.column>
   );
}

export default memo(ErrorPage);
